var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h3", { staticClass: "page-heading" }, [
            _vm._v("Administration panel")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "head__users" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "Button",
                _vm._b(
                  {
                    on: {
                      click: function($event) {
                        return _vm.openAddUser()
                      }
                    }
                  },
                  "Button",
                  _vm.addButton,
                  false
                )
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "v-card",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.users,
                  search: _vm.search
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c("td", [
                          _c("div", { staticClass: "media__image" }, [
                            props.item.profileImage
                              ? _c("img", {
                                  attrs: {
                                    src: props.item.profileImage,
                                    alt: "user image"
                                  }
                                })
                              : _c("span", [
                                  _c("i", { staticClass: "far fa-image" })
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.email))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(props.item.firstName) +
                              " " +
                              _vm._s(props.item.lastName)
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.roles,
                                "item-value": "label",
                                "item-text": "label",
                                outlined: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.updateMemberRole(props.item)
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "selection",
                                    fn: function(ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { right: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _c(
                                                        "a",
                                                        _vm._g(
                                                          {
                                                            attrs: {
                                                              slot: "activator",
                                                              flat: "",
                                                              small: ""
                                                            },
                                                            slot: "activator"
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                item.label
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(item.title) + " ")
                                            ])
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: props.item.role,
                                callback: function($$v) {
                                  _vm.$set(props.item, "role", $$v)
                                },
                                expression: "props.item.role"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("v-switch", {
                              on: {
                                change: function($event) {
                                  return _vm.changeStatus(props.item)
                                }
                              },
                              model: {
                                value: props.item.status,
                                callback: function($$v) {
                                  _vm.$set(props.item, "status", $$v)
                                },
                                expression: "props.item.status"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(props.item.formatedCreatedAt))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(props.item.formatedUpdatedAt))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "Button",
                              _vm._b(
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.removeMember(props.item)
                                    }
                                  }
                                },
                                "Button",
                                _vm.remove,
                                false
                              )
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.add_user,
            callback: function($$v) {
              _vm.add_user = $$v
            },
            expression: "add_user"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { "padding-top": "0px" },
                      attrs: { "grid-list-sm": "" }
                    },
                    [
                      _c("h5", [
                        _c("i", { staticClass: "fas fa-plus" }),
                        _vm._v(" Add new user")
                      ]),
                      _vm._v(" "),
                      _vm.errorMessage
                        ? _c(
                            "div",
                            {
                              staticClass: "alert alert-danger",
                              attrs: { role: "alert" }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.errorMessage) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.error
                        ? _c("div", { staticClass: "alert alert-danger" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.error) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-50" },
                        _vm._l(_vm.elements, function(item, index) {
                          return _c(
                            "div",
                            { key: index },
                            [
                              _c(
                                item.component,
                                _vm._b(
                                  {
                                    tag: "components",
                                    on: {
                                      input: function($event) {
                                        var i = arguments.length,
                                          argsArray = Array(i)
                                        while (i--) argsArray[i] = arguments[i]
                                        return _vm.getValue.apply(
                                          void 0,
                                          [item.name, item].concat(argsArray)
                                        )
                                      }
                                    }
                                  },
                                  "components",
                                  Object.assign(item, {
                                    width:
                                      item.component == "Input"
                                        ? null
                                        : item.width
                                  }),
                                  false
                                )
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "Button",
                    _vm._b(
                      {
                        on: {
                          click: function($event) {
                            return _vm.addUser()
                          }
                        }
                      },
                      "Button",
                      _vm.saveButton,
                      false
                    )
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "manage__users" }, [
      _c("p", [_vm._v("Manage Users")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71c5ff2f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c5ff2f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AdminPanel.vue
// module id = null
// module chunks = 